import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ALERT_LEVEL } from "../../../constants";
import useApi from "../../../utils/restUtil";
import { alert } from "../../common/Alert";
import Confirm from "../../common/Confirm";
import SearchBar from "../../common/search/SearchBar";
import { hideSpinner, showSpinner } from "../../common/spinner/Spinner";
import Invite from "./Invite";
import styles from "./Invites.module.css";

const Invites = () => {
  const { t } = useTranslation();
  const { get, del } = useApi();

  const [invites, setInvites] = useState([]);
  const [selectedInvite, setSelectedInvite] = useState([]);
  const [searchText, setSearchText] = useState("");

  const loadInvites = useCallback(() => {
    showSpinner();
    get(`/invites`, { email: { $regex: "^.*" + searchText + ".*", $options: "i" } })
      .then((resp) => {
        if (resp && resp.data) setInvites(resp.data);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(hideSpinner);
  }, [get, searchText]);

  const deleteInvite = (id) => {
    showSpinner();
    del("/invites/" + id)
      .then((resp) => {
        if (resp && resp.status === 200) {
          alert(t("Deleted successfully"), ALERT_LEVEL.SUCCESS);
          loadInvites();
        }
      })
      .finally(hideSpinner);
  };

  useEffect(() => {
    loadInvites();
  }, [loadInvites]);

  return (
    <div>
      <div className="row mb-2">
        <div className={`col mt-3`}>
          <SearchBar
            searchText={searchText}
            setSearchText={setSearchText}
            onClick={() => loadInvites()}
            onKeyPress={() => loadInvites()}
          />
        </div>
        <div className="col mt-3">
          <div className={`${styles["actionBtns"]}`}>
            <button
              className="btn btn-icon btn-secondary"
              data-toggle="modal"
              data-target="#inviteModal"
              data-backdrop="static"
              data-keyboard="false"
            >
              <span className="btn-inner--icon">
                <i className="fas fa-plus"></i>
                <span className="btn-inner--text">{t("Invite")}</span>
              </span>
            </button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="table-responsive">
              <div className="">
                <table className="table align-items-center">
                  <thead className="thead-light">
                    <tr>
                      <th>{t("No.")}</th>
                      <th>{t("Email")}</th>
                      <th>{t("Role")}</th>
                      <th>{t("Organization")}</th>
                      <th>{t("Status")}</th>
                      <th>{t("Action")}</th>
                    </tr>
                  </thead>
                  <tbody className="list">
                    {invites.map((invite, idx) => {
                      return (
                        <tr key={invite.id}>
                          <td>{idx + 1}</td>
                          <td>{invite.email}</td>
                          <td>{t(invite.role.name)}</td>
                          <td>{invite.organization.name}</td>
                          <td>{t(invite.status?.toUpperCase())}</td>
                          <td>
                            <span
                              className={`fa fa-lg fa-trash text-danger`}
                              data-toggle="modal"
                              data-target="#inviteDeleteModal"
                              data-backdrop="static"
                              data-keyboard="false"
                              onClick={(e) => {
                                setSelectedInvite(invite);
                              }}
                            ></span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Invite loadInvites={loadInvites} />
      <Confirm
        modalId="inviteDeleteModal"
        text={
          <>
            {t(`Are you sure you want to delete the invite sent to`) + " "}
            <b>{selectedInvite.email}</b>
          </>
        }
        onYesClick={() => deleteInvite(selectedInvite.id)}
        level={ALERT_LEVEL.DANGER}
      />
    </div>
  );
};

export default Invites;
